import { useParams } from "@tanstack/react-router";
import { EditIcon } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/base/button";
import { useCanUpdateTournament } from "@/components/tournaments/context";
import {
  AssignWildcardForm,
  type WildcardOpponent,
} from "@/components/tournaments/controls/assign-wildcard";

export type WildcardProps = {
  matchId: number;
  a: boolean;
  opponent?: WildcardOpponent;
};

export function Wildcard({ matchId, opponent, a }: WildcardProps) {
  const canEdit = useCanUpdateTournament();

  const [isOpen, setIsOpen] = useState(false);

  const { tournamentId: tournamentIdStr, divisionId: divisionIdStr } =
    useParams({
      from: "/tournaments/$tournamentId/$divisionId/{-$tab}",
    });

  const tournamentId = Number.parseInt(tournamentIdStr, 10);
  const divisionId = Number.parseInt(divisionIdStr, 10);

  return (
    <div className="flex flex-row items-center space-x-4">
      <span>Wildcard</span>

      {canEdit && (
        <>
          <Button variant="icon" onPress={() => setIsOpen(true)}>
            <EditIcon size={14} />
          </Button>

          <AssignWildcardForm
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            tournamentId={tournamentId}
            tournamentDivisionId={divisionId}
            opponent={opponent}
            matchId={matchId}
          />
        </>
      )}
    </div>
  );
}
